import { configureStore } from "@reduxjs/toolkit";
import combineReducers from './../CombineReducers/combineReducers';

export default configureStore({
  reducer: combineReducers,
  devTools: true,
}); 